<template>
  <div id="mpm-top">
    <service-header :auth="auth"/>
    <!-- ヒーローエリアPC -->
    <!-- cssの display-pc(display: none) で切り替えてもvideoやimgの読み込みは行われてしまうため v-ifで切り替える-->
    <div v-if="!isSP" class="mainvisual">
      <div class="curtain" ref="curtain" :class="{'appear-trans': allVideoReady}"
        :style="{height: videoHeight + 'px', width: curtainTopEdgeWidthPC + 'px',
          'clip-path': `polygon(0 0, ${curtainTopEdgeWidthPC}px 0, ${curtainTopEdgeWidthPC - curtainOverwrapWidth}px ${videoHeight}px, 0 ${videoHeight}px)`}"
      >
        <!-- キャッチコピー -->
        <p class="catch-copy" :class="{'appear-trans': curtainAppeared}" v-html="$t('mpm_hero1')"></p>
        <div class="service-name-container" :class="{'appear-trans': appearServiceName}">
          <p class="service-name">Moving<br>Photo Maker</p>
          <img class="brand-icon" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/icon/mpm_logo.svg"/>
        </div>
      </div>

      <!-- サムネイル (videoHeightを基準に大きさを調整する)-->
      <div class="thumbnail-container" v-show="curtainAppeared" :style="{left: curtainBottomEdgeWidthPC + 5 + 'px', height: thumbnailHeightPC + 'px'}">
        <img class="thumbnail-image" :class="{'appear-trans': firstVideoGifStarted}" :src="heroThumbnailURL" :style="{height: thumbnailHeightPC + 'px'}"/>
        <img ref="thumbnailOverlayPC" class="overlay" :src="transparent1x1ImgSrcB64" :style="{height: thumbnailHeightPC + 'px'}"/>
      </div>

      <!-- 背景の動画 -->
      <div class="movie-container" ref="movieContainer" :style="{height: videoHeight + 'px'}">
        <div class="video-padding" :style="{height: videoHeight + 'px', 'margin-right': videoPaddingWidthPC + 'px'}"></div>
        <video class="hero-video" :class="{'appear-trans': allVideoReady}" :height="videoHeight" :width="videoWidth" ref="video0" @canplay="onVideoReadyPC(0)" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video/hero1.mp4" playsinline muted></video>
        <video class="hero-video" :height="videoHeight" :width="videoWidth"  ref="video1" @canplay="onVideoReadyPC(1)" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video/hero2.mp4" playsinline muted></video>
        <video class="hero-video" :height="videoHeight" :width="videoWidth" ref="video2" @canplay="onVideoReadyPC(2)" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video/hero3.mp4" playsinline muted></video>
      </div>
      <!-- 動画左側にある目隠し。 videoのopacityを0にしても表示が消えないため。-->
      <div class="movie-container-cover-left" :style="{height: videoHeight + 'px', width: curtainBottomEdgeWidthPC + 'px'}"></div>

      <!-- 3つの動画の後にループ(初期位置にスクロールを戻す)時に目隠しする -->
      <div ref="movieContainerOverlay" class="movie-container-overlay"
        :style="{height: videoHeight + 'px', width: videoWidth + 'px'}"></div>
    </div>

    <!-- ヒーローエリアMobile -->
    <!-- PCとの違いは動画を画面横幅いっぱい表示する + 動画切り替え前に画面をブリンクしない -->
    <div v-else class="mainvisual">
      <div class="curtain" ref="curtain">
        <!-- キャッチコピー -->
        <p class="catch-copy" :class="{'appear-trans': curtainAppeared}" v-html="$t('mpm_hero1')"></p>
        <div class="service-name-container" :class="{'appear-trans': appearServiceName}">
          <p class="service-name">Moving<br>Photo Maker</p>
          <img class="brand-icon" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/icon/mpm_logo.svg"/>
        </div>
        <!-- サムネイル -->
        <div class="thumbnail-container" v-show="curtainAppeared">
          <img class="thumbnail-image" :class="{'appear-trans': firstVideoGifStarted}" :src="heroThumbnailURL"/>
          <img ref="thumbnailOverlayMobile" class="overlay" :src="transparent1x1ImgSrcB64"/>
        </div>
      </div>

      <!-- 背景の動画 -->
      <div class="movie-container" ref="movieContainer" :style="{height: videoHeight + 'px'}">
        <video type="video/mp4" class="hero-video" :class="{'appear-trans': allVideoReady}"
         :height="videoHeight" :width="videoWidth" ref="video0" @canplay="onVideoReadyMobile(0)"
         src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video/hero1_sp.mp4" playsinline autoplay muted>
        </video>
        <video type="video/mp4" class="hero-video"
          :height="videoHeight" :width="videoWidth"  ref="video1" @canplay="onVideoReadyMobile(1)"
          src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video/hero2_sp.mp4" playsinline autoplay muted>
        </video>
        <video type="video/mp4" class="hero-video"
         :height="videoHeight" :width="videoWidth" ref="video2" @canplay="onVideoReadyMobile(2)"
         src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video/hero3_sp.mp4" playsinline autoplay muted>
        </video>
      </div>
    </div>

    <!-- ドロップエリア① -->
    <div class="drop_area width-mv" :style="{'margin-top': firstDropAreaMarginTop ? firstDropAreaMarginTop + 'px' : '-5.8vw'}">
      <v-layout align-center justify-center column fill-height v-if="logined" class="drop_area-inner" @drop.prevent="onDropFile" @dragenter.prevent @dragover.prevent>
        <img class="upload-img" src="https://storage.googleapis.com/cre8tiveai_public_files/img/ep/icon/upload_icon.svg">
        <p class="white--text display-pc">{{ $t("glb_upload2") }}</p>
        <v-btn class="text-none drop_area-button" :class="isLongLang ? 'small-text' : ''" round outline dark @click="openFileSelect">
          {{ $t("glb_upload3") }}
        </v-btn>
        <input ref="inputFile" type="file" id="target_image" name="target_image" accept=".jpg, .jpeg, .png" @change="onSelectFile"/>
      </v-layout>

      <v-layout align-center justify-center column fill-height v-else class="drop_area-inner">
        <img class="upload-img" src="https://storage.googleapis.com/cre8tiveai_public_files/img/ep/icon/upload_icon.svg">
        <v-btn class="text-none drop_area-button" :class="isLongLang ? 'small-text' : ''" @click="auth.login('login')" round outline dark>
          {{ $t("glb_upload1") }}
        </v-btn>
      </v-layout>
    </div>

    <!-- Moving Photo Makerとは -->
    <div class="about">
      <div class="base-container">
        <div class="display-pc brand-container">
          <v-img class="brand-icon" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/icon/mpm_logo.svg"></v-img>
        </div>
        <h1 class="about-heading">{{ $t("mpm_head1") }}</h1>
        <p class="about-paragraph">
          {{ $t("mpm_explanation" )}}
        </p>
      </div>
    </div>

    <!-- 広告 -->
    <ad-responsive></ad-responsive>

    <!-- 動画例 -->
    <div class="samples-container">
      <div class="base-container">
        <p class="heading">{{ $t("mpm_head2") }}</p>
        <div class="movie-list-container">
          <div class="movie-container" v-for="n in samplesNum" :key="n">
            <p class="movie-name">{{ $t(sampleMovieI18nNameId(n)) }}</p>
            <!-- PCはタップで動画プレイヤーをポップアップ -->
            <img class="movie-thumbnail display-pc" :src="sampleThumbnailURL(n)"
              @click="playSampleVideoPC(n)" />
            <div class="movie-description-balloon display-pc">
              <p>{{ $t(sampleMovieI18nDescriptionId(n)) }}</p>
              <img class="balloon-tail" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/balloon_tail.svg">
            </div>
            <!-- Mobileはサムネイルタップでiframeに差し替えて、再タップで強制全画面で動画が再生される -->
            <img v-if="selectedMovieId != n" class="movie-thumbnail display-sp" :src="sampleThumbnailURL(n)"
              @click="playSampleVideoSP(n)" />
            <iframe v-if="selectedMovieId == n" class="movie-player-sp display-sp" :src="selectedMovieURL"
              :width="sampleWidthSP"
              :height="sampleHeightSP"
              style='border: none;'
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <p class="samples-caution">{{ $t("mpm_sample_caution") }}</p>
      </div>
    </div>
    <!-- 動画プレイヤー
      NOTE. attachを指定しなければ #app直下にdialog要素が挿入されるが、影響範囲を絞ったstyleを指定しやすくするため#mpm-samplesを指定 -->
    <v-dialog v-model="showVideoPlayer" width="640" height="480" content-class="video-player" attach="#mpm-top">
      <iframe :src="selectedMovieURL"
        width="640"
        height="480"
        style='border: none;'
        allow="autoplay"
      >
      </iframe>
    </v-dialog>
    <div class="btn-container">
      <v-btn class="to-sample-btn" color="#45BA4D" dark round large block to="/mpm/samples">
        {{ $t("mpm_to_samples") }}
      </v-btn>
    </div>

    <!-- 広告 -->
    <ad-responsive></ad-responsive>

    <!-- 自作イラストも動画化可能 -->
    <div class="from-illust">
      <div class="base-container">
        <p class="heading">{{ $t("mpm_head3") }}</p>
        <div class="compare-container">
          <div class="compare-before">
            <v-img class="before-pic" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/original_illust.webp"></v-img>
          </div>
          <div class="arrow-container">
            <img class="transfer-arrow" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/arrow.svg" />
          </div>
          <div class="compare-after">
            <!-- iPad Pro以上(PC含む）-->
            <iframe
              class="hide-lg-down"
              src="https://www.youtube.com/embed/NaOxKpOjaOU?controls=0"
              width="600"
              height="450"
              style='border: none;'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
              allowfullscreen/>
            <!-- iPad Pro未満(Mobile)-->
            <iframe
              class="hide-lg-up"
              src="https://www.youtube.com/embed/NaOxKpOjaOU?controls=0"
              width="327"
              height="246"
              style='border: none;'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
              allowfullscreen/>
          </div>
        </div>
      </div>
    </div>

    <!-- フロー -->
    <div class="spec-container">
      <p class="heading head4">{{ $t("mpm_head4") }}</p>
      <div class="flow-container">
        <img v-if="isSP" class="pic_to_movie" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/1pic_to_14movie_sp.webp"/>
        <img v-else class="pic_to_movie" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/1pic_to_14movie.svg"/>
        <!-- 1枚の写真 -->
        <div class="source-pic-balloon">
          <p>{{ $t("mpm_from") }}</p>
          <img class="balloon-tail" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/balloon_tail.webp">
        </div>
        <!-- 14種類の動画 -->
        <div class="result-videos-balloon">
          <p>{{ $t("mpm_to") }}</p>
          <img class="balloon-tail" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/balloon_tail.webp">
        </div>
      </div>
      <p class="spec-title">{{ $t("glb_mpm_spec_title") }}</p>
      <!-- 仕様 -->
      <movie-spec :large="true" />
    </div>

    <!-- MPMを支える技術 -->
    <div class="about-technology">
      <div class="base-container">
        <p class="heading head5">{{ $t("mpm_head5") }}</p>
        <p class="technology-detail">
          {{ $t("mpm_tech_txt") }}
        </p>
      </div>
    </div>

    <!-- ドロップエリア② -->
    <div class="drop_area">
      <v-layout align-center justify-center column fill-height v-if="logined" class="drop_area-inner" @drop.prevent="onDropFile" @dragenter.prevent @dragover.prevent>
        <img class="upload-img" src="https://storage.googleapis.com/cre8tiveai_public_files/img/ep/icon/upload_icon.svg">
        <p class="white--text display-pc">{{ $t("glb_upload2")}}</p>
        <v-btn class="text-none drop_area-button" :class="isLongLang ? 'small-text' : ''" round outline dark @click="openFileSelect">
          {{ $t("glb_upload3") }}
        </v-btn>
        <input ref="inputFile" type="file" id="target_image" name="target_image" accept=".jpg, .jpeg, .png" @change="onSelectFile"/>
      </v-layout>

      <v-layout align-center justify-center column fill-height v-else class="drop_area-inner">
        <img class="upload-img" src="https://storage.googleapis.com/cre8tiveai_public_files/img/ep/icon/upload_icon.svg">
        <v-btn class="text-none drop_area-button" :class="isLongLang ? 'small-text' : ''" @click="auth.login('login')" round outline dark>
          {{ $t("glb_upload1") }}
        </v-btn>
      </v-layout>
    </div>

    <!-- 広告 -->
    <ad-responsive></ad-responsive>

    <!-- 利用のSTEP -->
    <div class="usage_steps">
      <h2 class="usage_steps-heading">{{ $t("mpm_head6") }}</h2>
      <div class="base-container">
        <div class="steps-flex">
          <div class="one-step">
            <p class="step-number">①</p>
            <h3 class="step-title">
              <!-- ファイルをアップロード -->
              <span>{{ $t("mpm_step1") }}</span>
            </h3>
            <div class="icon-container">
              <img class="upload-icon" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/usage_step1.svg"/>
            </div>
            <p class="step-description">
              {{ $t("mpm_step_txt1") }}
            </p>
          </div>
          <div class="one-step">
            <p class="step-number">②</p>
            <h3 class="step-title">
              <!-- 課金処理を実行 -->
              <span>{{ $t("mpm_step2") }}</span>
            </h3>
            <div class="icon-container">
              <img class="payment-icon" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/usage_step2.svg"/>
            </div>
            <p class="step-description">
              {{ $t("mpm_step_txt2") }}
            </p>
          </div>
          <div class="one-step">
            <p class="step-number">③</p>
            <h3 class="step-title">
              <!-- メールを確認 -->
              <span>{{ $t("mpm_step3") }}</span>
            </h3>
            <div class="icon-container">
              <img class="mail-icon" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/usage_step3.svg"/>
            </div>
            <p class="step-description">
              {{ $t("mpm_step_txt3") }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 動画化してみるボタン -->
    <v-btn dark class="button btn-cv text-none" @click.stop="onTapExecButton">
      {{ $t("mpm_exec") }}
    </v-btn>

    <!-- 広告 -->
    <ad-responsive></ad-responsive>

    <!-- こんなことに使うことができます -->
    <div class="realization">
      <h2 class="realization-heading">
        <span class="maker-line hide-lg-down">
          {{ $t("mpm_head7") }}
        </span>
        <span class="hide-lg-up">
          {{ $t("mpm_head7") }}
        </span>
      </h2>
      <div class="base-container">
        <!-- 動画素材を創ろう -->
        <div class="realization-container">
          <div class="realization-head">
            <h3 class="realization-title">
              <span class="realization-title-text">
                {{ $t("mpm_usage_title1") }}
              </span>
            </h3>
          </div>
          <div class="realization-body">
            <div class="realization-body-previous">
              <p class="realization-description">
                {{ $t("mpm_usage_txt1") }}
              </p>
              <!-- うまい/速い/安い -->
              <div class="appeal-points-container">
                <div class="appeal-point"><p :class="{'small' : $t('mpm_usage_value1').length > 7}">{{ $t("mpm_usage_value1") }}</p></div>
                <div class="appeal-point"><p :class="{'small' : $t('mpm_usage_value2').length > 7}">{{ $t("mpm_usage_value2") }}</p></div>
                <div class="appeal-point"><p :class="{'small' : $t('mpm_usage_value3').length > 7}">{{ $t("mpm_usage_value3") }}</p></div>
              </div>
              <!-- 値段 翻訳文言にHTML及びスタイルを埋め込んであることに注意-->
              <div class="mpm-price-container">
                <span v-html="$t('mpm_usage_type')"/>
                <span v-html="$t('mpm_usage_price')"/>
              </div>
              <div class="price-caution"><p>＊</p>&nbsp;<p>{{ $t("mpm_usage_caution1") }}</p></div>
              <div class="price-caution"><p>＊</p>&nbsp;<p>{{ $t("mpm_usage_caution2") }}</p></div>
              <div class="price-caution"><p>＊</p>&nbsp;<a href="#price" class="link-to-price">{{ $t("mpm_usage_caution3") }}</a></div>
            </div>
            <div class="realization-body-following">
              <img class="source-pic" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video_element1.svg">
              <div class="source-pic-balloon">
                <p>{{ $t("mpm_from") }}</p>
                <img class="balloon-tail" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/balloon_tail.webp">
              </div>
              <img class="logo" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video_element2.svg">
              <img class="arrow" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/arrow.svg">
              <img class="hide-lg-down result-videos" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video_element3.svg">
              <img class="hide-lg-up   result-videos" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/video_element3_sp.svg">
              <div class="result-videos-balloon">
                <p>{{ $t("mpm_to") }}</p>
                <img class="balloon-tail" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/balloon_tail.webp">
              </div>
            </div>
          </div>
        </div>

        <!-- SNSに動画をuploadしよう -->
        <div class="realization-container">
          <div class="realization-head">
            <h3 class="realization-title">
              <span class="realization-title-text">
                {{ $t("mpm_usage_title2") }}
              </span>
            </h3>
          </div>
          <div class="realization-body">
            <div class="realization-body-previous">
              <p class="realization-description">
                {{ $t("mpm_usage_txt2") }}
              </p>
            </div>
            <div class="realization-body-following upload-to-sns">
              <div class="sns-container">
                <p>{{ $t("mpm_sns1") }}</p>
                <img v-if="isSP" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/sns1_sp.webp">
                <img v-else src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/sns1@2x.webp">
              </div>
              <div class="sns-container">
                <p>{{ $t("mpm_sns2") }}</p>
                <img v-if="isSP" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/sns2_sp.webp">
                <img v-else src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/sns2@2x.webp">
              </div>
              <div class="sns-container">
                <p>{{ $t("mpm_sns3") }}</p>
                <img v-if="isSP" src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/sns3_sp.webp">
                <img v-else src="https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/sns3@2x.webp">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Price -->
    <div id="price">
      <h2 class="price-heading">
          {{ $t("mpm_head8") }}
      </h2>
      <p class="price-caution">{{ $t("mpm_head8_sub") }}</p>
      <div class="base-container">
        <div class="price-container">
          <!-- エントリー -->
          <div class="price-item">
            <div class="plan-container">
              <p class="plan-name">{{ $t("mpm_plan1") }}</p>
              <p class="monthly-price">{{ $t("mpm_plan1_sub") }}</p>
            </div>
            <div class="mpm-price-container">
              <!--  翻訳マスタにHTML及びスタイルを埋め込む -->
              <div>
                <span v-html="$t('mpm_plan1_type')"/>
                <span v-html="$t('mpm_plan1_price')"/>
              </div>
            </div>
          </div>
          <!-- ライト -->
          <div class="price-item">
            <div class="plan-container">
              <p class="plan-name">{{ $t("mpm_plan2") }}</p>
              <p class="monthly-price">{{ $t("mpm_plan2_sub") }}</p>
            </div>
            <div class="mpm-price-container">
              <!--  翻訳マスタにHTML及びスタイルを埋め込む -->
              <div>
                <span v-html="$t('mpm_plan2_type')"/>
                <span v-html="$t('mpm_plan2_price')"/>
              </div>
              <p class="real-price">{{ $t("mpm_plan2_real") }}</p>
            </div>
          </div>
          <!-- メガ -->
          <div class="price-item">
            <div class="plan-container">
              <p class="plan-name">{{ $t("mpm_plan3") }}</p>
              <p class="monthly-price">{{ $t("mpm_plan3_sub") }}</p>
            </div>
            <div class="mpm-price-container">
              <!--  翻訳マスタにHTML及びスタイルを埋め込む -->
              <div>
                <span v-html="$t('mpm_plan3_type')"/>
                <span v-html="$t('mpm_plan3_price')"/>
              </div>
              <p class="real-price">{{ $t("mpm_plan3_real") }}</p>
            </div>
          </div>
        </div>
        <!-- 価格を見る -->
        <v-btn class="to-price no-deco text-none" round outline color="#22B56A" to="/price">
          {{ $t("mpm_to_price") }}
        </v-btn>
      </div>
    </div>

    <!-- 広告 -->
    <ad-responsive></ad-responsive>

    <!-- 仕様2  -->
    <div class="spec-container2">
      <p class="spec-title">{{ $t("glb_mpm_spec_title") }}</p>
      <movie-spec :large="true" />
    </div>

    <!-- API連携 -->
     <div class="about-api">
      <div class="base-container">
        <h2 class="about-api-h2">
          <span class="maker-line for-api">
            cre8tiveAI
          </span>
          <br class="display-sp">
          <span class="maker-line for-api">
            Moving Photo Maker API
          </span>
        </h2>
        <h3 class="about-api-heading">
          <span>{{ $t("mpm_api1") }}</span>
        </h3>
        <p class="api-descriptions">
          {{ $t("mpm_api2") }}
        </p>
        <v-img class="main-illust display-pc" src="https://storage.googleapis.com/cre8tiveai_public_files/img/ep/api_main_illust_pc.svg">
          <p class="p-request" :class="isLongLang ? 'small-text' : ''">{{ $t("mpm_api3") }}</p>
          <p class="p-get" :class="isLongLang ? 'small-text' : ''">{{ $t("mpm_api4") }}</p>
          <p class="p-service" :class="isLongLang ? 'small-text' : ''">{{ $t("mpm_api5") }}</p>
        </v-img>
        <v-img class="main-illust display-sp" contain src="https://storage.googleapis.com/cre8tiveai_public_files/img/pr/renewal/07_about_api/api_main_illust_sp.svg">
          <p class="p-request" :class="isLongLang ? 'small-text' : ''">{{ $t("mpm_api3") }}</p>
          <p class="p-get" :class="isLongLang ? 'small-text' : ''">{{ $t("mpm_api4") }}</p>
          <p class="p-service" :class="isLongLang ? 'small-text' : ''">{{ $t("mpm_api5") }}</p>
        </v-img>
        <v-btn class="api-btn" to="/#g-form-area">
          <span class="dotted">{{ $t("mpm_api6") }}</span>
        </v-btn>
      </div>
    </div>

    <!-- 依頼モーダル -->
    <order-modal-container
      ref="orderModalRef"
      :show="showOrderModal"
      @close="closeOrderModal"
    >
    </order-modal-container>
  </div>
</template>

<script>
import smoothscroll from 'smoothscroll-polyfill'
import ServiceHeader from '@/components/ServiceHeader.vue'
import AdResponsive from '@/components/GoogleAdsense/AdResponsive.vue'
import MovieSpec from "./MovieSpec.vue"
import OrderModalContainer from "./OrderModalContainer.vue"
import {judgeIPadByWindowSize} from '../util'

export default {
  name: 'MovingPhotoMakerTop',
  props: ['auth'],
  components: {
    MovieSpec,
    OrderModalContainer,
    ServiceHeader,
    AdResponsive
  },
  data() {
    // TODO: https://bitbucket.org/k-sugawara_radius5/creative_ai/pull-requests/209 で話した改修を行ったら $vuetifyを使うよう修正したい
    //return window.innerWidth < this.$vuetify.breakpoint.thresholds.sm
    const isSP = window.innerWidth < 768 // iPad未満
    // 動画自体のサイズ
    const rawVideoWidth = isSP ? 375 : 1280
    const rawVideoHeight = isSP ? 500 : 720
    const curtainOverwrapWidth = 255 // 動画の上にカーテン上端が重なる長さ
    const minPCVideoLeftPadding = 270
    const minPCVideoWidth = 980

    let videoWidth = isSP ? window.innerWidth : window.innerWidth - minPCVideoLeftPadding
    // PCにて元動画サイズ以上の再生エリアがあったとしてもmaxで元動画サイズとする
    if (!isSP) {
      if (videoWidth > rawVideoWidth) {
        videoWidth = rawVideoWidth
      } else if (videoWidth < minPCVideoWidth) {
        videoWidth = minPCVideoWidth
      }
    }

    const videoHeight = rawVideoHeight * videoWidth / rawVideoWidth
    let curtainTopEdgeWidthPC = window.innerWidth - videoWidth + curtainOverwrapWidth
    if (curtainTopEdgeWidthPC < 500) {
      curtainTopEdgeWidthPC = 500
    }
    const curtainBottomEdgeWidthPC = curtainTopEdgeWidthPC - curtainOverwrapWidth
    const videoPaddingWidthPC = curtainTopEdgeWidthPC * 2
    // PCのHeroエリアサムネイルの高さ(XDではvideoHeight710に対しサムネイル143)
    const thumbnailHeightPC = 143 * videoHeight / 710
    // ヒーローエリア直下のdrop areaの位置調整
    const headerHeightPC = 128
    const dropAreaHeightPC = 200
    const firstDropAreaMarginTop = !isSP && window.innerHeight > headerHeightPC + rawVideoHeight + dropAreaHeightPC ? -48 : null

    // サンプル動画のサイズ
    const sampleWidthSP = (window.innerWidth - 2 * 24/* 画面両端のpadding */) / 2 - 4 /* 要素同士の間隔*/
    const sampleHeightSP = sampleWidthSP * 480 / 640
    return {
      playHeroAnim: true,
      isSP: isSP,
      videoWidth: videoWidth,
      videoHeight: videoHeight,
      curtainOverwrapWidth: curtainOverwrapWidth,
      curtainTopEdgeWidthPC: curtainTopEdgeWidthPC,
      curtainBottomEdgeWidthPC: curtainBottomEdgeWidthPC,
      videoPaddingWidthPC: videoPaddingWidthPC,
      thumbnailHeightPC: thumbnailHeightPC,
      samplesNum: this.$store.state.movingPhotoMaker.samplesNum,
      showOrderModal: false,
      heroThumbnailURL: isSP ? 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail1_sp@2x.webp'
        : 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail1.webp',
      heroVideoReady: [false, false, false],
      allVideoReady: false,
      curtainAppeared: false, // 左端からカーテンが現れたらキャッチコピー等を登場
      firstVideoGifStarted: false, // thumbnailOverlay(PC|Mobile) がめくれたことにサムネイルを表示する
      appearServiceName: false,
      showVideoPlayer: false,
      selectedMovieId: null,
      selectedMovieURL: '',
      // サムネイルブリンクが終わったら一度透明に差し替え、再度overlayGifSrcB64に差し替えるとアニメーションが走る
      transparent1x1ImgSrcB64: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFFWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDIgNzkuMTY0NDYwLCAyMDIwLzA1LzEyLTE2OjA0OjE3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMiAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjAtMTEtMTBUMTM6MjI6NTIrMDk6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIwLTExLTEwVDEzOjI1OjMyKzA5OjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDIwLTExLTEwVDEzOjI1OjMyKzA5OjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMSIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9IkRvdCBHYWluIDE1JSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozNDFlMDUxNS1jY2ZlLTQ1ODEtYTg0NS00NzMyODhmNGQ1ZDUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzQxZTA1MTUtY2NmZS00NTgxLWE4NDUtNDczMjg4ZjRkNWQ1IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MzQxZTA1MTUtY2NmZS00NTgxLWE4NDUtNDczMjg4ZjRkNWQ1Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDozNDFlMDUxNS1jY2ZlLTQ1ODEtYTg0NS00NzMyODhmNGQ1ZDUiIHN0RXZ0OndoZW49IjIwMjAtMTEtMTBUMTM6MjI6NTIrMDk6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4yIChNYWNpbnRvc2gpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrAfvL0AAAALSURBVAjXY/jPAAACAQEAqsKFNgAAAABJRU5ErkJggg==",
      firstDropAreaMarginTop: firstDropAreaMarginTop,
      sampleWidthSP: sampleWidthSP,
      sampleHeightSP: sampleHeightSP
    }
  },
  computed: {
    logined() {
      return this.$store.getters['user/logined']
    },
    // ヒーローエリアのサムネイルに被せるブリンクgif (srcを動的に切り替えることでアニメーションが開始する)
    overlayGifSrcB64() {
      return this.isSP ? "data:image/gif;base64,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"
        : "data:image/gif;base64,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"
    }
  },
  methods: {
    // ヒーローエリアの動き(PC)
    async onVideoReadyPC(index) {
      this.heroVideoReady.splice(index, 1, true)
      // => 全部がtrueになったら allVideoReadyによりアニメーションが開始する
      // 黄色いカーテンが表示された頃にサムネイルをブリンク + キャッチコピー表示
      // (カーテンの表示完了を this.$refs.curtain.addEventListener('transitionend', callback) で取ろうとしたが、
      //  callbackが短期間に複数回呼ばれるため断念した)
      if (this.allVideoReady === false && this.heroVideoReady.every((elm) => elm === true)) {
        this.allVideoReady = true
        while (this.playHeroAnim) {
          await this.playHeroAnimPC()
        }
      }
    },
    async playHeroAnimPC() {
      this.curtainAppeared = true
      this.$refs.movieContainerOverlay.style.opacity = 1.0
      this.heroThumbnailURL = 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail1.webp'
      this.$refs.movieContainer.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      })
      // scrollが終わった頃合いに表示したいので少し待つ。
      // 初回実行時は allVideoReady=true によりカーテンが表示された頃合いでもある。
      // (scrolToのの終了タイミングを厳密に見ると少しややこしいのでシンプルに固定ms待つこととした)
      await new Promise(resolve => setTimeout(resolve, 350));
      this.$refs.movieContainerOverlay.style.opacity = 0.0

      return new Promise((resolve) => {
        this.$nextTick(async () => {
          // v-show でgifのDOMが表示された頃
          this.$refs.thumbnailOverlayPC.src = this.overlayGifSrcB64
          this.$refs.video0.play()
          // 右端からvideoをslideして登場
          this.$refs.movieContainer.scrollTo({
            left: this.videoPaddingWidthPC - this.curtainBottomEdgeWidthPC,
            top: 0,
            behavior: 'smooth'
          })
          // 少し遅れてロゴが下からせり上がる
          const logoAppearDelay = 250
          await new Promise(resolve => setTimeout(resolve, logoAppearDelay));
          this.appearServiceName = true
          this.firstVideoGifStarted = true

          // サムネイル切り替え
          const videoDuration = 3600
          const thumbnailChangeDelay = 400
          await new Promise(resolve => setTimeout(resolve, videoDuration - logoAppearDelay - thumbnailChangeDelay));
          this.$refs.thumbnailOverlayPC.src = this.transparent1x1ImgSrcB64
          this.$refs.thumbnailOverlayPC.src = this.overlayGifSrcB64
          await new Promise(resolve => setTimeout(resolve, thumbnailChangeDelay));
          this.heroThumbnailURL = 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail2.webp'

          // 2番目のvideo表示
          this.$refs.video1.play()
          // 右端からvideoをslideして登場
          this.$refs.movieContainer.scrollTo({
            left: this.videoPaddingWidthPC - this.curtainBottomEdgeWidthPC + this.videoWidth,
            top: 0,
            behavior: 'smooth'
          })

          await new Promise(resolve => setTimeout(resolve, videoDuration - thumbnailChangeDelay));
          this.$refs.thumbnailOverlayPC.src = this.transparent1x1ImgSrcB64
          this.$refs.thumbnailOverlayPC.src = this.overlayGifSrcB64
          await new Promise(resolve => setTimeout(resolve, thumbnailChangeDelay));
          this.heroThumbnailURL = 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail3.webp'

          // 3番目のvideo表示
          this.$refs.video2.play()
          // 右端からvideoをslideして登場
          this.$refs.movieContainer.scrollTo({
            left: this.videoPaddingWidthPC - this.curtainBottomEdgeWidthPC + this.videoWidth * 2,
            top: 0,
            behavior: 'smooth'
          })
          // mobileだと一度はループ再生してしまう？のを防ぐ対応を一応PC(というかTableを想定して)入れておく
          await new Promise(resolve => setTimeout(resolve, 3200));
          this.$refs.thumbnailOverlayPC.src = this.transparent1x1ImgSrcB64
          this.firstVideoGifStarted = false
          // thumbnail-imageが消えるのを見計らってからresolve
          await new Promise(resolve => setTimeout(resolve, 300));
          resolve()
        })
      })
    },
    // ヒーローエリアの動き(Mobile)
    async onVideoReadyMobile(index) {
      this.heroVideoReady.splice(index, 1, true)
      if (this.allVideoReady === false && this.heroVideoReady.every((elm) => elm === true)) {
        this.allVideoReady = true
        while (this.playHeroAnim) {
          await this.playHeroAnimMobile()
        }
      }
    },
    async playHeroAnimMobile() {
      this.$refs.video0.pause()
      this.$refs.video1.pause()
      this.$refs.video2.pause()

      // PCと違ってカーテンは最初から表示
      this.curtainAppeared = true
      this.heroThumbnailURL = 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail1_sp@2x.webp'
      this.$refs.movieContainer.scroll({
        left: 0,
        top: 0,
        behavior: 'auto'
      })
      return new Promise((resolve) => {
        this.$nextTick(async () => {
          // v-show でgifのDOMが表示された頃
          console.log(this.$refs.thumbnailOverlayMobile.style.opacity)
          this.$refs.thumbnailOverlayMobile.src = this.overlayGifSrcB64
          this.$refs.video0.play()

          // 少し遅れてロゴが下からせり上がる
          const logoAppearDelay = 750
          await new Promise(resolve => setTimeout(resolve, logoAppearDelay));
          this.appearServiceName = true
          this.firstVideoGifStarted = true

          // サムネイルの切り替えと同時に2番目のvideoに切り替え
          const videoDuration = 3600 // 動きが終了するのは(=movieの長さは)4000ms後
          const thumbnailChangeDelay = 400
          await new Promise(resolve => setTimeout(resolve, videoDuration - logoAppearDelay - thumbnailChangeDelay));
          this.$refs.thumbnailOverlayMobile.src = this.transparent1x1ImgSrcB64
          this.$refs.thumbnailOverlayMobile.src = this.overlayGifSrcB64
          await new Promise(resolve => setTimeout(resolve, thumbnailChangeDelay));
          this.heroThumbnailURL = 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail2_sp@2x.webp'

          this.$refs.video1.play()
          // 右端からvideoをslideして登場
          this.$refs.movieContainer.scroll({
            left: this.videoWidth,
            top: 0,
            behavior: 'smooth'
          })

          // 3番目のvideo表示
          await new Promise(resolve => setTimeout(resolve, videoDuration - thumbnailChangeDelay));
          this.$refs.thumbnailOverlayMobile.src = this.transparent1x1ImgSrcB64
          this.$refs.thumbnailOverlayMobile.src = this.overlayGifSrcB64
          await new Promise(resolve => setTimeout(resolve, thumbnailChangeDelay));
          this.heroThumbnailURL = 'https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/hero_thumbnail3_sp@2x.webp'

          this.$refs.video2.play()
          // 右端からvideoをslideして登場
          this.$refs.movieContainer.scroll({
            left: this.videoWidth * 2,
            top: 0,
            behavior: 'smooth'
          })
          // mobileだと一度はループ再生してしまう？ため明示的に透明gifに戻す
          await new Promise(resolve => setTimeout(resolve, 3200));
          this.$refs.thumbnailOverlayMobile.src = this.transparent1x1ImgSrcB64
          this.firstVideoGifStarted = false
          // thumbnail-imageが消えるのを見計らってからresolve
          await new Promise(resolve => setTimeout(resolve, 300));
          resolve()
        })
      })
    },
    // ファイル選択
    async onDropFile(e) {
      // モーダルを開く前にstoreをreset (変換完了して戻ってきた場合でも確実にresetする)
      this.$store.commit('movingPhotoMaker/reset')

      if(!this.logined) {
        return
      }
      const files = []
      // FileList型はforEachできないためforで回す
      for (var i = 0; i < e.dataTransfer.files.length; i++) {
        const file = e.dataTransfer.files[i]
        files.push(file)
      }
      this.$store.commit('movingPhotoMaker/setTargetImageFile', files)
      await this.$store.dispatch("movingPhotoMaker/preparePayment")
      this.showOrderModal = true;
    },
    openFileSelect() {
      this.$refs.inputFile.click()
    },
    async onSelectFile(e) {
      this.$store.commit('movingPhotoMaker/reset')

      const files = []
      for (var i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i]
        files.push(file)
      }
      this.$store.commit('movingPhotoMaker/setTargetImageFile', files)
      await this.$store.dispatch("movingPhotoMaker/preparePayment")
      this.showOrderModal = true;
    },
    // 動画化してみるボタン押下
    onTapExecButton() {
      if (this.logined) {
        this.openFileSelect()
        return
      } else {
        this.auth.login('login')
      }
    },
    sampleMovieI18nNameId(id) {
      return this.$store.getters['movingPhotoMaker/sampleI18nNameId'](id)
    },
    sampleMovieI18nDescriptionId(id) {
      return this.$store.getters['movingPhotoMaker/sampleI18nDescriptionId'](id)
    },
    sampleThumbnailURL(id) {
      return this.$store.getters['movingPhotoMaker/sampleThumbnailURLForTopPage'](id)
    },
    sampleMovieURL(id) {
      return this.$store.getters['movingPhotoMaker/sampleMovieURLForTopPage'](id)
    },
    playSampleVideoPC(id) {
      this.showVideoPlayer = true
      this.selectedMovieURL = this.sampleMovieURL(id)
    },
    playSampleVideoSP(id) {
      this.selectedMovieId = id
      this.selectedMovieURL = this.sampleMovieURL(id)
    },
    closeOrderModal() {
      this.showOrderModal = false
      this.$refs.inputFile.value = ''
    }
  },
  async created() {
    // iOSでもスムーズなスクロールをさせる
    smoothscroll.polyfill()
    // 結果ページ(=header非表示)から戻ってきた時を考慮し、明示的にtrue
    this.$store.commit("screen/headerVisible", true);
    this.$store.commit("screen/footerVisible", true);

    // iPadだとvideoのcanplayが発火しない(iOS14.2/chrome87.0.4280.77, safariでは発火したりしなかったりする？)
    // ので、しばらく待って再生が始まってなかったら始めようとしてみる
    // (mp4ファイルの取得は問題なくできているっぽい)
    if (judgeIPadByWindowSize) {
      await new Promise(resolve => setTimeout(resolve, 5200));
      if (this.allVideoReady === false) {
        this.allVideoReady = true
        this.playHeroAnimPC()
      }
    }
  },
  unmounted() {
    //this.$refs.curtain.removeEventListener('transitionend', this.curtainAnimListener)
    this.playHeroAnim = false
  }
}

</script>

<style lang="scss">
// こちらはglobal scopeなことに注意!
// vuetifyにより生成/挿入される要素(dialog)は、scopedなcssではstyleを指定できないのでこちらで指定
// (なぜなら .aaa[data-v-3d74eb98] のような乱数の属性が自動指定される(ことでscopeを区切っている)ため)
#mpm-top .video-player {
  background-color: black;
  // vuetify側のデフォルトshadowでは下端が灰色の線のように見えてしまうため上書き
  box-shadow: none;
}
</style>

<style lang="scss">
@import "../../assets/scss/_variables.scss";

.mpm-price-container {
  // 翻訳マスタに入れるHTMLから参照するクラス
  //   scopedだと自動で属性(data-v-NNNN) がつくが、翻訳マスタに入れるHTMLにはつかないため
  //   非scopedなcssとしてここに定義
  .string {
    font-size: 28px;
    color: #424242;
    @include mq-down {
      font-size: 18px;
    }
  }
  .number {
    font-size: 64px;
    color: #22B56A;
    @include mq-down {
      font-size: 56px;
    }
  }
  .left-margin {
    margin-left: 50px;
    @include mq-down {
      margin-left: 20px;
    }
  }
  .left-margin-small {
    margin-left: 34px;
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/scss/_variables.scss";
@import url(https://use.typekit.net/ddm1tzj.css);

@mixin container_base($width: 1028px) {
  padding: 0 56px;
  overflow: hidden;

  @include mq-down(md) {
    padding: 0 24px;
  }

  .base-container {
    position: relative;
    max-width: $width;
    margin-left: auto;
    margin-right: auto;
  }
}
@mixin base_subheading {
  text-align: center;
  font-size: 40px;
  font-weight: 500;

  @include mq-down(lg) {
    font-size: 32px;
  }

  @include mq-down(md) {
    font-size: 400;
    font-size: 25px;
    line-height: 30px;
  }
}

.mainvisual {
  position: relative;

  .curtain {
    position :absolute;
    top: 0;
    opacity: 0;
    left: -300px;
    z-index: 5;
    box-sizing: border-box;
    padding-top: 64px;
    padding-right: 80px;
    background-color: rgba(240, 255, 41, 0.95);
    display: flex;
    flex-flow: column;
    align-items: flex-end;

    // PCのみ
    transition: all 0.2s;
    &.appear-trans {
      opacity: 1;
      left: 0;
    }

    @include mq-down {
      // alphaをつけると裏側に描画が透けて負荷が高いためつけない
      background-color: rgb(226, 255, 0);
      top: 40px;
      left: 11px;
      opacity: 1;
      width: 200px;
      height: unset;
      padding: 17px 10px 18px;
      align-items: flex-start;
    }

    .catch-copy {
      font-size: 46px;
      position: relative;
      right: -100px;
      opacity: 0;
      width: 340px;
      text-align: left;
      font-weight: 300;
      margin: 0;

      @include mq-down {
        right: -60px;
        font-size: 25px;
        line-height: 32px;
        width: 180px; // curtainの 200 - 2 * 10(padding)
      }

      transition: all 0.3s ease-out;
      @include mq-down {
        transition: all 0.6s ease-out;
      }
      &.appear-trans {
        opacity: 1;
        right: 0px;
      }
    }
    .service-name-container{
      display: flex;
      flex-flow: row;
      position: relative;
      top: 50px;
      margin-right: 144px;
      opacity: 0;
      @include mq-down {
        top: 16px;
        margin-top: 18px;
        margin-right: 0;
        align-items: flex-end;
      }

      transition: all 0.4s ease-out;
      &.appear-trans {
        opacity: 1;
        top: 0;
      }

      .service-name {
        font-size: 18px;
        color: #424242;
        text-align: left;
        font-weight: 700;
        margin: 0;
        @include mq-down {
          font-size: 13px;
          line-height: 14px;
        }
      }
      .brand-icon {
        margin-left: 18px;
        width: 64px;
        @include mq-down {
          margin-left: 10px;
          width: 39px;
          max-height: 22px;
          //margin-bottom: 4px;
        }
      }
    }
  }
  .thumbnail-container {
    position: absolute;
    // PCのサイズはvideoHeightを基準にサイズを調整
    bottom: 30%;
    z-index: 20;

    @include mq-down {
      bottom: unset;
      left: 168px;
      bottom: -32px;
      width: 75px;
      height: 95px;
    }

    .thumbnail-image {
      position: absolute;
      top: 0;
      left: 0;
      // PCのサイズはvideoHeightを基準にサイズを調整
      opacity: 0;
      @include mq-down {
        width: 75px;
        height: 95px;
      }


      transition: opacity 0.2s;
      transition-delay: 0.2s;
      &.appear-trans {
        opacity: 1;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      // PCのサイズはvideoHeightを基準にサイズを調整
      @include mq-down {
        width: 75px;
        height: 95px;
      }
    }
  }

  .movie-container {
    //height: 720px;
    width: 100%;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    overflow-x: scroll;
    scroll-behavior: 'smooth';
    &::-webkit-scrollbar {
      display: none;
    }
    .video-padding {
      background-color: white;
    }
    .hero-video {
      // 動画は 1280x720
      opacity: 1;
      transition: opacity 0.4s;
      transition-delay: 0.4s;
    }
  }

  .movie-container-cover-left {
    position: absolute;
    top: 0;
    left: -14px;
    //opacity: 0.8;
    box-shadow: 14px 0 24px 24px rgba(255,255,255,1);
    background-color: white;
  }

  .movie-container-overlay {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    background-color: white;
  }
}

.heading {
  text-align: center;
  font-weight: 500;
  font-size: 40px;
  color: #424242;

  @include mq-down(lg) {
    font-size: 36px;
  }

  @include mq-down {
    font-size: 400;
    font-size: 25px;
    line-height: 30px;
  }
}


.about {
  @include container_base(1040px);
  margin-top: 64px;
  @include mq-down {
    margin-top: 0;
  }

  .brand-container {
    border-radius: 99px;
    box-shadow: 0px 3px 6px #00000029;
    width: 110px;
    height: 110px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .brand-icon {
      width: 90px;
      flex: none;
      //margin-left: 4px;
    }
  }

  .about-heading {
    text-align: center;
    font-weight: 500;
    font-size: 40px;
    max-width: 720px;
    line-height: 55px;
    margin-top: 32px;
    margin-left: auto;
    margin-right: auto;
    color: #424242;
    @include mq-down {
      font-size: 25px;
      font-weight: 400;
      line-height: 30px;
      margin-top: 38px;
    }
  }

  .about-paragraph {
    margin-top: 32px;
    text-align: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 48px;
    color: #424242;
    @include mq-down {
      font-size: 16px;
      line-height: 32px;
      font-weight: 400;
    }
  }

  .about-subheading {
    margin-top: 96px;
    @include base_subheading;
    @include mq-down {
      margin-top: 88px;
      font-weight: 400;
    }
  }
}

// ドロップエリア
.drop_area {
  background: linear-gradient(99deg, #A6FF7B, #007A4B);
  max-width: 980px;
  margin: 40px auto 0;
  border-radius: 16px;
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  bottom: 0;
  height: 188px;

  &.width-mv {
    // PCは画面高さに応じて微調整する
    margin-top: -5.8vw;
  }

  @include mq-up(xl) {
    height: 200px;
  }

  @include mq-down(xl) {
    height: 200px;
    height: 182px;
  }

  @include mq-down(lg) {
    margin-right: 32px;
    margin-left: 32px;
  }

  @include mq-down(md) {
    height: 172px;
  }

  @include mq-down(sm) {
    height: 172px;
  }

  @include mq-down(md) {
    margin-right: 16px;
    margin-left: 16px;
    height: initial;
    padding: 10px;

    &.width-mv {
      margin-top: -24px;
    }
  }

  @include mq-down(xs) {
    margin-right: 8px;
    margin-left: 8px;
    height: 120px;
    padding: 8px;
  }

  p {
    margin-bottom: 0px;

    @include mq-up {
      font-size: calc(0.135vw + 12px);
    }
  }

  .drop_area-inner {
    max-width: 976px;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: 2px dashed #fff;
    padding: 8px;

    .upload-img {
      height: 48px;
      margin-top: 8px;
      margin-bottom: 8px;

      @include mq-down(md) {
        margin-bottom: 0px;
      }

      @include mq-down(sm) {
        height: 40px;
      }
    }

    .drop_area-button {
      font-size: 14px;
      margin: 8px;
      @include mq-down {
        padding: 0 32px;
      }
      @include mq-down(sm) {
        font-size: 12px;
      }
      @include mq-down(xs) {
        &.small-text {
          font-size: 10px;
          padding: 0 16px;
        }
      }
    }
  }

  input {
    display: none;
  }
}

.samples-container {
  @include container_base(1040px);
  margin-top: 64px;
  @include mq-down {
    margin-top: 81px;
  }
  .heading {
    color: #424242;
  }
  .movie-list-container {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-end;
    justify-content: center;
    margin-top: 30px;
    .movie-container {
      margin-top: 45px;
      @include mq-down {
        width: calc(50% - 4px);
        &:nth-child(odd) {
          margin-left: 0;
          margin-right: 4px;
        }
        &:nth-child(even) {
          margin-left: 4px;
          margin-right: 0;
        }
      }
      .movie-name {
        padding: 0;
        margin: 0;
        font-size: 30px;
        line-height: 30px;
        font-weight: 500;
        color: #45BA4D;
        @include mq-down {
          width: 100%;
          word-wrap: break-word;
          font-size: 24px;
          line-height: 24px;
        }
      }
      .movie-thumbnail {
        margin: 16px 40px 0px 40px;
        width: 300px;
        height: 225px;
        @include mq-down {
          margin: 32px 0 0;
          width: 100%;
          height: unset;
        }
      }
      .movie-description-balloon {
        position: relative;
        margin: 29px 40px 0;
        width: 300px;
        height: 100px;
        border-radius: 8px;
        background-color: #45BA4D;
        padding: 12px 10px 10px;
        p {
          font-size: 16px;
          line-height: 24px;
          color: white;
          margin: 0;
          padding: 0;
          text-align: left;
        }
        .balloon-tail {
          position: absolute;
          top: 5px;
          left: 50%;
          transform: translateX(-50%) translateY(-100%);
        }
      }
      .movie-player-sp {
        margin-top: 32px;
      }
    }
  }
  .samples-caution {
    margin: 124px auto 0;
    max-width: 840px;
    font-size: 15px;
    line-height: 24px;
    color: #424242;
    @include mq-down {
      margin-top: 65px;
      font-size: 14px;
    }
  }
}

.btn-container {
  a {
    &:hover {
      text-decoration: none;
    }
  }
  // Material Design準拠の関係でボタン文言は複数行表示不可なので
  // 複数行表示を可能にするための対応
  /*div.v-btn__content {
    width: 100% !important;
    white-space: normal !important;
  }
    ^ 上手く効かせられなかったのでSPではfont-sizeを小さめにする
  */
  .to-sample-btn {
    color: white;
    margin: 70px auto 0;
    max-width: 680px;
    height: 100px;
    border-radius: 20px;
    font-size: 30px;
    &:hover {
      text-decoration: none;
    }
    @include mq-down {
      max-width: 327px;
      height: 74px;
      font-size: 21px;
    }
  }
}
.from-illust {
  @include container_base(1040px);
  p {
    margin: 173px auto 40px;
    padding: 0;
    @include mq-down {
      margin: 107px auto 35px;
    }
  }
}
.compare-container {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @include mq-down(lg) {
    flex-direction: column;
    align-items: center;
  }
  .before-pic {
    width: 300px;
    height: 300px;
    margin: 0 5px;
    @include mq-down(lg) {
      width: 200px;
      height: 200px;
      margin: 0;
    }
  }
  .arrow-container {
    background-color: white;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    position: absolute;
    bottom: 230px;
    transform: translateY(-50%) rotateX(180deg) rotateZ(-90deg);
    left: 276px;
    z-index: 2;
    overflow: hidden;
    box-shadow: 0px 3px 6px rgba(black, .16);

    @include mq-down(lg) {
      bottom: 220px;
      left: calc(50% - 35px);
      transform: translateY(0%) rotateY(180deg) rotateX(0deg) rotateZ(0deg);
      //height: 18vw;
      //width: 18vw;
    }

    .transfer-arrow {
      width: 56px;
      height: 56px;
      margin-top: 4px;
      margin-right: 8px;
    }
  }
  .compare-after {
    width: 600px;
    height: 450px;
    margin: 0 5px;
    @include mq-down(lg) {
      width: 327px;
      height: 246px;
      margin: 18px auto 0;
    }
  }
}
.spec-container {
  background-color: #CBFFCD;
  @include container_base(1040px);
  margin-top: 70px;
  padding-bottom: 92px;
  @include mq-down {
    margin-top: 112px;
    padding-bottom: 45px;
  }
  .head4 {
    margin: 92px auto 114px;
    @include mq-down {
      margin: 63px auto 46px;
    }
  }
  .flow-container {
    position: relative;
    margin: 0 auto;
    max-width: 1040px;
    @include mq-down {
      margin: 111px auto 0;
      width: 100%;
    }
    .pic_to_movie {
      width: 797px;
      max-width: 100%;
      @include mq-down {
        width: 300px;
      }
    }
    .source-pic-balloon {
      height: 64px;
      border-radius: 20px;
      background-color: #22B56A;
      position: absolute;
      top: 4px;
      left: calc(50% + 100px);
      padding: 12px 16px;
      @include mq-down {
        height: 48px;
        border-radius: 10px;
        top: -60px;
        left: unset;
        right: 48px;
        padding: 6px 8px;
      }
      p {
        margin: 0;
        padding: 0;
        font-size: 28px;
        color: white;
        text-align: left;
        @include mq-down {
          font-size: 21px;
        }
      }
      .balloon-tail {
        width: 24px;
        position: absolute;
        top: 60px;
        left: 20px;
        @include mq-down {
          top: 46px;
          left: 12px;
        }
      }
    }
    .result-videos-balloon {
      height: 86px;
      border-radius: 20px;
      background-color: #22B56A;
      position: absolute;
      bottom: 46%;
      right: 0;
      padding: 12px 16px;
      @include mq-down {
        height: 64px;
        top: 186px;
        right: 12px;
        padding: 8px 12px;
      }
      p {
        margin: 0;
        padding: 0;
        font-size: 39px;
        color: white;
        text-align: left;
        @include mq-down {
          font-size: 30px;
        }
      }
      .balloon-tail {
        width: 36px;
        position: absolute;
        bottom: -18px;
        left: 20px;
        @include mq-down {
          left: 12px;
        }
      }
    }
  }
  .spec-title {
    font-size: 24px;
    color: #22B56A;
    margin-top: 145px;
    margin-left: 0;
    margin-bottom: 28px;
    padding: 0;
    @include mq-down {
      margin-top: 84px;
    }
  }
}
.about-technology {
  background-color: #A6FF7B;
  @include container_base(1024px);
  .head5 {
    margin: 92px auto 46px;
    @include mq-down {
      margin: 54px auto 32px;
    }
  }
  .technology-detail {
    max-width: 810px;
    margin: 0 auto 86px;
    font-size: 24px;
    color: #424242;
    line-height: 48px;
    @include mq-down {
      width: 100%;
      margin: 0 auto 62px;
      font-size: 16px;
      line-height: 32px;
    }
  }
}

.usage_steps {
  @include container_base(1028px);
  margin-top: 160px;
  background-color: #45BA4D;
  text-align: center;
  padding: 0 32px;
  @include mq-down(lg) {
    margin-top: 68px;
  }

  * {
    color: white;
  }

  .usage_steps-heading {
    font-size: 48px;
    margin-top: 48px;
    @include mq-down(lg) {
      font-size: 25px;
      margin-top: 37px;
    }
  }

  .steps-flex {
    margin-top: 48px;
    display: flex;
    margin-bottom: 64px;

    @include mq-down(lg) {
      flex-direction: column;
      align-items: center;
      margin-bottom: 0;
    }

    .one-step {
      flex: 1 300px;

      @include mq-up {
        &:nth-child(2) {
          margin: 0 56px;

          @include mq-down(lg) {
            margin: 0 32px;
          }
        }
      }
      @include mq-down(lg) {
        margin-bottom: 64px;
      }

      .step-number {
        font-size: 48px;
        @include mq-down(lg) {
          font-size: 40px;
          margin-bottom: 0px;
        }
      }
      .step-title {
        font-size: 27px;
        font-weight: 500;
        height: 76px;
        text-align: center;
        margin: 0 -12px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;

        @include mq-down(lg) {
          font-size: calc(0.87vw + 17.4px);
          margin-bottom: 17px;
        }

        @include mq-down(lg) {
          height: initial;
          font-weight: medium;
          //font-size: calc(1.79vw + 18.3px);
          font-size: 25px;
          margin: 17px auto 25px;
        }
      }
      .icon-container {
        min-height: 425px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        @include mq-down(lg) {
          min-height: unset;
        }
        .upload-icon {
          width: 271px;
          @include mq-down(lg) {
            width: 158px;
          }
        }
        .payment-icon {
          height: 267px;
          @include mq-down(lg) {
            height: 200px;
          }
        }
        .mail-icon {
          margin-top: 56px;
          width: 209px;
          @include mq-down(lg) {
            margin-top: 0;
            width: 182px;
          }
        }
      }

      .step-description {
        font-size: 18px;
        text-align: left;
        font-weight: 500;
        line-height: 30px;
        @include mq-down(lg) {
          margin-top: 22px;
          margin-bottom: 0;
        }
        @include mq-down {
          font-size: 14px;
          line-height: 28px;
        }
      }
    }
  }
}

.btn-cv {
  color: white;
  width: 680px;
  max-width: 88vw;
  white-space: normal;
  min-height: 116px;
  font-size: 32px;
  font-weight: 400;
  margin: 64px auto;
  border-radius: 99px;
  background: linear-gradient(120deg, #A6FF7B, #007A4B);
  //box-shadow: 0 2px 10px rgba(0,0,0,0.4) !important;
  &:hover {
    //box-shadow: 1px 6px 15px rgba(0,0,0,0.4) !important;
    &::before {
      background: linear-gradient(120deg, #C6FF9B, #45BA4D);
      opacity: .5;
    }
  }
  @include mq-down {
    min-width: 0px;
    max-width: 448px;
    width: 88vw;
    height: 80px;
    margin: 40px auto;
    min-height: unset;
    font-size: 25px;
  }
  /deep/ .v-btn__content {
    width: 100%;
  }
}
a {
  color: inherit;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
}

.realization {
  @include container_base;

  .realization-heading {
    font-size: 48px;
    margin-top: 48px;
    margin: 112px -32px 77px;
    color: #424242;

    @include mq-down(lg) {
      max-width: 90%;
      font-size: 25px;
      margin: 64px auto 47px;
    }
  }
  .realization-container {
    margin-bottom: 96px;
    @include mq-down(lg) {
      margin-bottom: 38px;
    }
    .realization-head {
      position: relative;
      display: flex;
      margin-bottom: 44px;
      @include mq-down(lg) {
        flex-direction: column-reverse;
        align-items: center;
        margin-bottom: 8px;
      }
      .realization-title {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: relative;
        padding: 32px 32px;
        color: #424242;
        border: dashed 3px #424242;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #A6FF7B;
        z-index: 3;
        @include mq-down(lg) {
          padding: 16px 16px;
          //margin-top: 28px;
          margin-bottom: 32px;
          border: dashed 2px #424242;
          height: 88px;
        }
        .realization-title-text {
          position: relative;
          z-index: 1;
          font-weight: bold;
          font-size: 32px;
          color: #424242;
          @include mq-down(cn) {
            font-size: calc(3.91vw + -10px);
          }
          @include mq-down(lg) {
            font-size: calc(2.24vw + 10.8px);
          }
        }
      }
      &:after {
        content: '';
        background-image: url(https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/dotted_balloon_tail.svg);
        background-size: contain;
        width: 37px;
        height: 42px;
        position: absolute;
        top: calc(100% - 13px);
        left: 50%;
        transform: translateX(-50%);
        z-index: 5;
        @include mq-down(lg) {
          width: 20.4px;
          height: 26.4px;
          top: unset;
          bottom: 10px;
          background-image: url(https://storage.googleapis.com/cre8tiveai_public_files/img/mpm/dotted_balloon_tail_sp.svg);
        }
      }
    }
    .realization-body {
      position: relative;
      display: flex;
      @include mq-down(lg) {
        flex-direction: column-reverse;
        align-items: center;
      }
      .realization-body-previous {
        width: 365px;
        box-sizing: border-box;
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &.less-right-margin {
          margin-right: 8px;
        }
        @include mq-down(lg) {
          flex: initial;
          margin: 0;
          width: 100%;
        }
        .realization-description {
          font-size: 18px;
          text-align: left;
          margin-bottom: 32px;
          line-height: 30px;
          color: #424242;
          &.short-text {
            width: 284px;
          }
          @include mq-down(lg) {
            font-size: calc(0.89vw + 11.2px);
            margin-top: 15px;
            margin-bottom: 16px;
          }
        }
        .appeal-points-container {
          position: relative;
          display: flex;
          flex-flow: row;
          width: 390px;
          @include mq-down(lg) {
            width: unset;
            margin: 0 auto;
          }
          .appeal-point {
            width: 130px;
            height: 130px;
            border-radius: 65px;
            background-color: #22B56A;
            @include mq-down(lg) {
              width: 113.6px;
              height: 113.6px;
            }
            &:nth-child(1) {
              position: relative;
              left: -8px;
              @include mq-down(lg) {
                left: 0px;
              }
            }
            &:nth-child(2) {
              position: relative;
              left: -16px;
              @include mq-down(lg) {
                left: -8px;
              }
            }
            &:nth-child(3) {
              position: relative;
              left: -24px;
              @include mq-down(lg) {
                left: -16px;
              }
            }
            p {
              font-size: 28px;
              color: white;
              // centering
              margin: 0;
              padding: 0;
              position: absolute;
              top: 50%;
              left: 50%;
              margin-right: -50%;
              transform: translate(-50%, -50%);
              &.small {
                font-size: 20px;
              }
            }
          }
        }
        .price-container {
          margin-top: 8px;
          margin-bottom: 8px;
        }
        .price-caution {
          display: flex;
          flex-flow: row;
          p {
            text-align: start;
            font-size: 18px;
            margin: 0;
            line-height: 30px;
            color: #424242;
            @include mq-down {
              font-size: 16px;
            }
          }
          .link-to-price {
            text-align: start;
            font-size: 18px;
            margin: 0;
            line-height: 30px;
            color: #22B56A;
            text-decoration: underline;
            @include mq-down {
              font-size: 16px;
            }
          }
        }
      }
      .present-previous-img-present {
        position: absolute;
        top: -18px;
        right: -12px;
      }
      .arrow-img {
        position: absolute;
        top: 96px;
        right: 82px;
        transform: rotateY(180deg);
        width: 68px;
        height: 68px;
      }
      .textile-previous-img-container {
        position: relative;
        .textile-previous-img {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 52px;
          @include mq-down {
            width: 60%;
          }
        }
        .arrow-img {
          position: absolute;
          top: 60%;
          right: 130px;
          transform: scale(-1, 1) rotate(90deg);
          width: 18%;
        }
      }
      .realization-body-following {
        position: relative;
        align-self: flex-end;
        width: 630px;
        height: 630px;
        &.upload-to-sns {
          height: 450px;
          display: flex;
          flex-flow: row;
          justify-content: space-evenly;
          align-items: center;
          @include mq-down(lg) {
            width: 100%;
            max-width: 100%;
          }
          @include mq-down {
            width: 100%;
            height: 1482px;
            flex-flow: column
          }
          .sns-container {
            display: flex;
            flex-flow: column;
            align-items: center;
            p {
              margin: 0 0 0 4px;
              padding: 0;
              font-size: 17px;
              @include mq-down {
                font-size: 25px;
                margin-top: 50px;
                margin-bottom: 23px;
              }
            }
            img {
              width: 180px;
              @include mq-down {
                width: 100%;
              }
            }
          }
        }
        background-color: #E2E2E2;
        @include mq-down(lg) {
          flex: initial;
          width: 100%;
          max-width: 512px;
          align-self: center;
          height: 800px;
        }
        .source-pic {
          width: 110px;
          position: absolute;
          top: 46px;
          left: calc(50% - 55px);
          @include mq-down(lg) {
            top: 114px;
            left: 94px;
            width: 138px;
            left: calc(50% - 69px);
          }
        }
        .source-pic-balloon {
          height: 58px;
          border-radius: 20px;
          background-color: #22B56A;
          position: absolute;
          top: 50px;
          //right: 38px;
          left: calc(50% + 68px);
          padding: 12px 16px;
          @include mq-down(lg) {
            height: 48px;
            border-radius: 10px;
            left: calc(50% - 70px);
            padding: 6px 8px;
          }
          p {
            margin: 0;
            padding: 0;
            font-size: 28px;
            color: white;
            text-align: left;
            @include mq-down(lg) {
              font-size: 21px;
            }
          }
          .balloon-tail {
            width: 24px;
            position: absolute;
            top: 56px;
            left: 20px;
            @include mq-down(lg) {
              top: 46px;
              left: 12px;
            }
          }
        }
        .logo {
          width: 382px;
          position: absolute;
          top: 198px;
          left: calc(50% - 191px);
          @include mq-down(lg) {
            width: 287px;
            top: 278px;
            left: calc(50% - 144px);
          }
        }
        .arrow {
          width: 64px;
          position: absolute;
          left: calc(50% - 32px);
          bottom: 228px;
          @include mq-down(lg) {
            bottom: 362px;
          }
        }
        .result-videos {
          width: 466px;
          height: 165px;
          position: absolute;
          left: calc(50% - 233px);
          bottom: 34px;
          @include mq-down(lg) {
            width: 300px;
            height: unset;
            left: calc(50% - 150px);
            bottom: 28px;
          }
        }
        .result-videos-balloon {
          height: 58px;
          border-radius: 20px;
          background-color: #22B56A;
          position: absolute;
          bottom: 225px;
          //right: 0;
          left: calc(50% + 48px);
          padding: 12px 16px;
          @include mq-down(lg) {
            border-radius: 24px;
            bottom: 245px;
            left: calc(50% - 110px);
            padding: 8px 12px;
          }
          p {
            margin: 0;
            padding: 0;
            font-size: 28px;
            color: white;
            text-align: left;
            white-space: nowrap;
            @include mq-down(lg) {
              font-size: 30px;
            }
          }
          .balloon-tail {
            width: 24px;
            position: absolute;
            bottom: -12px;
            left: 12px;
            @include mq-down(lg) {
              width: 32px;
              left: 12px;
              bottom: -16px;
            }
          }
        }
      }
    }
  }
}

.maker-line {
  &::before {
    background-color: #A6FF7B;
  }
  &.for-api {
    &::before {
      background-color: #f2ff52;
    }
  }
}


#price {
  @include container_base;
  @include mq-down {
    padding: 0 8px;
  }

  .price-heading {
    font-size: 48px;
    margin-top: 112px;
    color: #424242;
    @include mq-down {
      margin-top: 76px;
      margin-bottom: 20px;
    }
  }
  .price-caution {
    margin: 0;
    font-size: 18px;
    color: #424242;
    @include mq-down {
      font-size: 16px;
    }
  }
  .price-container {
    margin-top: 75px;
    padding: 0 48px;
    @include mq-down(lg) {
      padding: 0;
    }
    .price-item {
      display: flex;
      flex-flow: row;
      align-items: baseline;
      @include mq-down(lg) {
        flex-flow: column;
        justify-content: center;
        align-items: center;
      }
      .plan-container {
        width: 452px;
        @include mq-down(lg) {
          width: unset;
        }
        .plan-name {
          font-size: 28px;
          line-height: 28px;
          color: #22B56A;
          margin: 0;
          padding: 0;
          text-align: left;
          @include mq-down(lg) {
            font-size: 25px;
            text-align: center;
          }
        }
        .monthly-price {
          font-size: 16px;
          color: #424242;
          margin: 8px 0 0;
          text-align: left;
          @include mq-down(lg) {
            font-size: 16px;
            text-align: center;
          }
        }
      }
      .mpm-price-container {
        .real-price {
          font-size: 32px;
          line-height: 32px;
          color: #22B56A;
          text-align: right;
          margin: 0;
          @include mq-down(lg) {
            font-weight: 25px;
            font-weight: bold;
          }
        }
      }
      &:first-child {
        margin-bottom: 80px;
      }
      &:last-child {
        margin-top: 80px;
      }
    }
  }
  .to-price {
    width: 680px;
    height: 116px;
    font-size: 32px;
    border-radius: 58px;
    border-width: 2px;
    margin-top: 118px;
    @include mq-down(lg) {
      width: 88vw;
      height: 80px;
      font-size: 21px;
      border-radius: 40px;
    }
  }
}

.spec-container2 {
  @include container_base(1040px);
  margin-top: 70px;
  padding-bottom: 92px;

  .spec-title {
    font-size: 24px;
    color: #22B56A;
    margin-top: 145px;
    margin-left: 0;
    margin-bottom: 28px;
    padding: 0;
    @include mq-down {
      margin-top: 57px;
    }
  }
}

.about-api {
  background-color: #DEDEDE;
  margin-top: 0;
  overflow: hidden;
  @include container_base(924px);
  @include mq-down {
    margin-top: 65px;
  }

  .about-api-h2 {
    margin: 96px -8px 64px;
    padding: 0;
    font-size: 48px;
    color: #424242;

    @include mq-down {
      font-size: 25px;
      margin-top: 45px;
      margin-bottom: 34px;
    }

    .maker-line {
      @include mq-up {
        &:first-child {
          padding-right: 10px;
        }
      }
    }
  }

  .about-api-heading {
    margin-top: 72px;
    font-size: 48px;
    font-weight: 600;
    padding: 0 58px;

    span {
      color: #424242;
      max-width: 852px;
      line-height: 1.6;
    }

    @include mq-down(xxl) {
      font-size: calc(2.38vw + 13.7px);
    }

    @include mq-down(lg) {
      margin-top: 32px;
    }

    @include mq-down(md) {
      margin-top: 0px;
      font-size: 25px;
      line-height: 28px;
      padding: 0;
    }
  }

  .api-descriptions {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    padding: 0 58px;
    color: #424242;

    @include mq-down(xxl) {
      font-size: calc(0.89vw + 7.1px);
    }
    @include mq-down(md) {
      margin-top: 24px;
      font-size: 16px;
      line-height: 32px;
      padding: 0;
    }
  }
  .main-illust {
    margin: 104px 40px 96px;
    position: relative;
    overflow: visible;
    @include mq-down(xxl) {
      margin: 104px calc(-8.93vw + 168.6px) 64px;
    }
    @include mq-down(md) {
      margin: 56px auto 0;
      padding: 0;
      max-width: 512px;
    }

    @mixin illust_text {
      position: absolute;
      font-size: 27px;
      font-weight: 600;
      line-height: 1.6;
      left: 50%;
      margin: 0;
      max-width: 360px;
      @include mq-down(xxl) {
        font-size: calc(1.82vw + 0.8px);
      }
      @include mq-down(lg) {
        font-size: calc(2.2vw + 2px);
        line-height: 1.6;
        max-width: 280px;
      }
      @include mq-down(md) {
        font-size: 14px;
        line-height: 18px;
        max-width: 110px;
        white-space: normal;
      }
    }
    @mixin small-text-template {
      font-size: 21px;
      @include mq-down(xxl) {
        font-size: calc(1.32vw + 0.8px);
      }
      @include mq-down(md) {
        font-size: 12px;
      }
    }
    .p-request {
      @include illust_text;
      transform: translate(-50%, -100%);
      top: 20%;
      white-space: normal;
      color: #424242;

      @include mq-down(md) {
        top: 38%;
        font-size: 12px;
        line-height: 1.2;
      }
      &.small-text {
        @include small-text-template;
      }
    }
    .p-get {
      @include illust_text;
      max-width: 288px;
      transform: translate(-50%, 0%);
      top: 72%;
      color: #424242;
      @include mq-down(xl) {

      }
      @include mq-down(md) {
        top: 70%;
        font-size: 12px;
        line-height: 1.2;
        white-space: normal;
      }
      &.small-text {
        @include small-text-template;
      }
    }
    .p-service {
      @include illust_text;
      font-size: 170%;
      line-height: 32px;
      letter-spacing: 0.96px;
      transform: translate(50%, 0%);
      width: 50%;
      top: 86%;
      left: initial;
      right: 15%;
      max-width: 40%;
      color: #424242;

      @include mq-down(xxl) {
        font-size: 24px;
      }
      @include mq-down(lg) {
        font-size: calc(1.73vw + 0.7px);
      }
      @include mq-down(md) {
        transform: translate(50%, 0%);
        font-size: 2.2vw;
        line-height: 20px;
        top: 84%;
        left: initial;
        right: 16.8%;
        width: initial;
        max-width: initial;
      }
      &.small-text {
        @include small-text-template;
      }
    }
  }
  .api-btn {
    margin: 32px 0 128px;
    width: 900px;
    height: 184px;
    font-size: 45px;
    font-weight: 500;
    line-height: 43px;
    border-radius: 999px;
    background-color: #707070 !important;

    .dotted {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 3px dashed white;
      border-radius: 99px;
      height: 164px;
      width: 880px;
      color: white;
    }
    @include mq-down(lg) {
      width: 327px;
      height: 80px;
      font-size: 16px;
      line-height: 14px;
      font-weight: 500;
      margin-bottom: 75px;
      .dotted {
        border: 2px dashed white;
        width: 317px;
        height: 70px;
      }
    }
    @media screen and (max-width:350px) {
      width: 290px;
      max-width: 82vw;
      font-size: 11px;
      .dotted {
        width: 280px;
        max-width: 78vw;
      }
    }
    &:hover {
      text-decoration: none;
    }
  }
}
</style>

<i18n src="@/locales/moving_photo_maker/top.json"></i18n>
